import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import listItems from 'flarum/common/helpers/listItems';
import highlight from 'flarum/common/helpers/highlight';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import avatar from 'flarum/common/helpers/avatar';
import classList from 'flarum/common/utils/classList';
import Search from 'flarum/forum/components/Search';
import sortTags from 'flarum/tags/common/utils/sortTags';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import CustomFilterNav from '../../../../homepage/js/src/forum/components/CustomFilterNav';
import SelectDropdown from './components/SelectDropdown';

export default function () {
  override(IndexPage.prototype, 'view', function () {
    const bgBannerImgUrl = app.forum.attribute('baseUrl') + '/assets/images/banner_linear_200.png';
    const routeName = app.current.get('routeName');
    return (
      <div className="IndexPage" style={{ background: `url(${bgBannerImgUrl}) no-repeat center top` }}>
        {/* {this.hero()} */}
        <div className="container">
          <div className="sideNavContainer customSideNavContainer">
            <div className="customSideNavToolbar">
              <CustomFilterNav />
              <ul className="IndexPage-toolbar-action">{listItems(this.actionItems().toArray())}</ul>
            </div>
            <nav className="IndexPage-nav sideNav">
              <ul className="CustomSideNav">{listItems(this.sidebarItems().toArray())}</ul>
              <Search state={app.search} />
            </nav>
            <div className="Discussions-Header">
              <div className="header-topic">{app.translator.trans('dvdfab-discussions.forum.topic')}</div>
              <div className="header-people">{app.translator.trans('dvdfab-discussions.forum.people')}</div>
              <div className="header-replies">{app.translator.trans('dvdfab-discussions.forum.replies')}</div>
              {routeName !== 'byobuPrivate' ? <div className="header-views">{app.translator.trans('dvdfab-discussions.forum.views')}</div> : null}
              {/* {routeName !== 'byobuPrivate' ? <div className="header-likes">{app.translator.trans('dvdfab-discussions.forum.likes')}</div> : null} */}
              <div className="header-activity">{app.translator.trans('dvdfab-discussions.forum.activity')}</div>
              <div className="header-operations"></div>
            </div>
            {/* <div className="IndexPage-results sideNavOffset">{this.contentItems().toArray()}</div> */}
            <div className="IndexPage-results sideNavOffset">{this.contentItems().toArray()}</div>
          </div>
        </div>
      </div>
    );
  });

  extend(IndexPage.prototype, 'contentItems', function (items) {
    if (items.has('toolbar')) {
      items.remove('toolbar');
    }
    return items;
  });

  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    const routeName = app.current.get('routeName');
    const tagName = m.route.param('tags') || '';
    let customLabel = '';
    if (tagName && routeName === 'tag') {
      const allTags = app.store.all('tags');
      const currentTag = allTags.find((tag) => tag.slug() === tagName);
      if (currentTag) {
        customLabel = currentTag.name();
      }
    }

    if (items.has('nav')) {
      items.setContent(
        'nav',
        <SelectDropdown
          customLabel={customLabel}
          buttonClassName="Button"
          className="App-titleControl"
          accessibleToggleLabel={app.translator.trans('core.forum.index.toggle_sidenav_dropdown_accessible_label')}
        >
          {this.navItems().toArray()}
        </SelectDropdown>
      );
    }
  });

  extend(IndexPage.prototype, 'actionItems', function (items) {
    if (items.has('markAllAsRead')) {
      items.remove('markAllAsRead');
    }
    if (items.has('refresh')) {
      items.remove('refresh');
    }
    items.add(
      'refresh',
      <Button
        title={app.translator.trans('core.forum.index.refresh_tooltip')}
        icon="fas fa-redo"
        className="Button Button--icon"
        onclick={() => {
          app.discussions.refresh();
          if (app.session.user) {
            app.store.find('users', app.session.user.id()!);
            m.redraw();
          }
        }}
      />
    );
    return items;
  });

  override(DiscussionListItem.prototype, 'contentView', function () {
    const discussion = this.attrs.discussion;
    const controls = DiscussionControls.controls(discussion, this).toArray();
    // 获取 userList 关系数据
    const user = discussion.user();
    let userList = discussion.userList ? discussion.userList() : [];

    const routeName = app.current.get('routeName');
    if (routeName === 'byobuPrivate') {
      userList = discussion.recipientUsers();
    }
    const tagName = m.route.param('tags') || '';
    let isSubTagPage = false;
    let isTagPage = false;
    if (routeName === 'tag' && tagName) {
      isTagPage = true;
      const allTags = app.store.all('tags');
      const currentTag = allTags.find((tag) => tag.slug() === tagName);
      if (currentTag && currentTag.isChild()) {
        isSubTagPage = true;
      }
    }

    const tags = this.attrs.discussion.tags() ? sortTags(this.attrs.discussion.tags()) : [];
    let tagsOptions = tags.map((tag: any) => ({
      label: tag.name(),
      value: tag.id(),
      color: tag.color(),
      slug: tag.slug(),
      description: tag.description(),
      isChild: tag.isChild(),
      parent_id: tag.parent() ? tag.parent().id() : '',
    }));
    if (isSubTagPage) {
      tagsOptions = [];
    } else if (isTagPage) {
      tagsOptions = tagsOptions.filter((tag: any) => tag.isChild);
    }

    const jumpTo = this.getJumpTo();
    const isUnread = discussion.isUnread();
    const isRead = discussion.isRead();
    return (
      <div className={classList('DiscussionListItem-content', 'Slidable-content', { unread: isUnread, read: isRead })}>
        <div className="Discussion-custom-item">
          <Link href={app.route.discussion(discussion, jumpTo)} className="header-topic">
            <div class="custom-DiscussionListItem-title">
              <ul className="DiscussionListItem-badges badges">{listItems(discussion.badges().toArray())}</ul>
              <h2 className="DiscussionListItem-title">{highlight(discussion.title(), this.highlightRegExp)}</h2>
            </div>
            {tagsOptions.length ? (
              <ul className="DiscussionListItem-tags">
                {tagsOptions.map((tag: any) => {
                  // 检查是否为二级分类（有parent_id）
                  const isChild = tag.isChild;
                  // 如果是二级分类，找到父级分类的颜色
                  const parentTag = isChild ? tagsOptions.find((t) => t.value === tag.parent_id) : null;
                  const parentColor = parentTag ? parentTag.color : null;

                  return (
                    <li key={tag.value}>
                      {isChild && parentColor ? (
                        <span
                          className="tag-icon tag-icon-child"
                          style={{
                            background: `linear-gradient(to right, ${parentColor} 50%, ${tag.color} 50%)`,
                          }}
                        ></span>
                      ) : (
                        <span className="tag-icon" style={{ backgroundColor: tag.color }}></span>
                      )}
                      <span className="DiscussionListItem-tag">{tag.label}</span>
                    </li>
                  );
                })}
              </ul>
            ) : null}
            {routeName === 'byobuPrivate' ? <div>{user.username()}</div> : null}
          </Link>
          <Link href={app.route.discussion(discussion, jumpTo)} className="header-people">
            {userList.length <= 5 ? (
              userList.map((user, index) => <div style={{ zIndex: index + 1 }}>{avatar(user)}</div>)
            ) : (
              <>
                {userList.slice(0, 5).map((user, index) => (
                  <div style={{ zIndex: index + 1 }}>{avatar(user)}</div>
                ))}
                <span style={{ zIndex: 7 }} className="remaining-count">
                  <span className="count">+{userList.length - 5}</span>
                </span>
              </>
            )}
          </Link>
          <Link href={app.route.discussion(discussion, jumpTo)} className="header-replies">
            {discussion.replyCount()}
          </Link>
          {routeName !== 'byobuPrivate' ? (
            <Link href={app.route.discussion(discussion, jumpTo)} className="header-views">
              {discussion.attribute('viewCount') || 0}
            </Link>
          ) : null}
          {/* {routeName !== 'byobuPrivate' ? (
            <Link href={app.route.discussion(discussion, jumpTo)} className="header-likes">
              {discussion.attribute('firstPost_likes_count') || 0}
            </Link>
          ) : null} */}
          {/* posts[0].attribute('likesCount') || 0 */}
          <Link href={app.route.discussion(discussion, jumpTo)} className="header-activity">
            {' '}
            {dayjs(discussion.lastPostedAt()).fromNow()}
          </Link>
          <div className="header-operations"></div>
          {/* <div className="header-operations">{this.controlsView(controls)}</div> */}
        </div>
      </div>
    );
  });

  extend(IndexPage.prototype, 'oninit', function () {
    const currentRoute = app.current.get('routeName');
    const previousRoute = app.previous.get('routeName');
    // console.log('previousRoute', previousRoute, currentRoute);
    // 检测从byobuPrivate相关路由切换到index的情况
    if (previousRoute === 'tags' && currentRoute === 'index') {
      app.discussions.refresh();
    }
    if (previousRoute === 'tags' && currentRoute === 'byobuPrivate') {
      app.discussions.refresh();
    }
  });
}
